function elementToString(currentElement) {
  const id = currentElement?.id ? `#${currentElement.id}` : '';
  const classes = currentElement?.classList
    ? Array.from(currentElement.classList)
        .map((c) => `.${c}`)
        .join('')
    : '';
  const tag = currentElement?.tagName?.toLowerCase() || '';

  return [tag, id, classes].join('');
}

function pathToString(path) {
  return path.reduce(function (previousValue, currentElement) {
    const currentElementString = elementToString(currentElement);

    if (!currentElementString) {
      return previousValue;
    }

    if (previousValue) {
      return `${currentElementString} > ${previousValue}`;
    }

    return currentElementString;
  }, '');
}

export function customEventTrigger(e) {
  const clickable = ['BUTTON', 'A'];
  if (e.composed && e.composedPath) {
    const path = e.composedPath();
    const clickableElement = path.find(
      (x) =>
        clickable.includes(x.tagName) ||
        (x.attributes && x.attributes['role'] && x.attributes['role'].value === 'button')
    );

    if (clickableElement) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'custom.click',
        custom_click: {
          element: clickableElement,
          elementId: clickableElement.id || '',
          elementClasses: clickableElement.className || '',
          elementUrl: clickableElement.href || clickableElement.action || '',
          elementTarget: clickableElement.target || '',
          clickText: clickableElement.innerText || '',
          // Potential solution for capturing text nodes. clickableElement.nodeName === `#text`
          // See https://www.microfocus.com/documentation/silk-test/200/en/silktestworkbench-help-en/SILKTEST-21EEFF3F-DIFFERENCEBETWEENTEXTCONTENTSINNERTEXTINNERHTML-REF.html.
          // See JS tab for WIP
          // clickText: clickableElement.textContent.trim() || '',
          originalEvent: e,
          // Additional values below.
          elementValue: clickableElement.value || '',
          elementType: clickableElement.type || '',
          path: pathToString(path),
          // formId: formElement !== null ? formElement.id : '',
          // formAction: formElement !== null ? formElement.action : '',
          // formClasses: formElement !== null ? formElement.className : '',
        },
      });

      // reset custom click data so it's not sent with future events
      window.dataLayer.push({
        custom_click: undefined,
      });
    }
  }
}
